import * as React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, makeStyles } from '@material-ui/core';
import { useIifImportSelector, IifImportSelectors } from '../store/modules/iifImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import DepositDistributionView from './DepositDistributionView';
import { useApplicationSettingsSelector, ApplicationSettingsSelectors, TaxMode } from '../store/modules/applicationSettings';
import AudCurrencyFormatter from '../utilities/currencyFormatter';

interface IDepositDistributionViewsProps {
    distributionView: number[];
    amount: number;
    tax: number;
    total: number;
}

const useStyles = makeStyles(theme => ({
    expandCell: {
        width: 75
    },
    indexCell: {
        width: 75
    },
    descriptionCell: {
    },
    taxCodeCell: {
        width: 220
    },
    amountCell: {
        width: 150
    },
    totalCell: {
        fontWeight: 'bold'
    },
    totalAmountCell: {
        fontWeight: 'bold'
    },
    hiddenCell: {
        border: 'none'
    }
}))

const DepositDistributionViews: React.FunctionComponent<IDepositDistributionViewsProps> = ({
    distributionView,
    amount,
    tax,
    total
}) => {
    const classes = useStyles();

    const taxMode = useApplicationSettingsSelector(ApplicationSettingsSelectors.selectTaxMode);

    if (!distributionView) {
        return null;
    }

    return (
        <Table aria-label="spanning table" size="small">
            <TableHead>
                <TableRow>
                    <TableCell className={classes.expandCell} />
                    <TableCell className={classes.indexCell}>#</TableCell>
                    <TableCell>Account</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell>Class</TableCell>
                    {/*<TableCell>Payment Method</TableCell>*/}
                    <TableCell className={classes.descriptionCell}>Description</TableCell>
                    <TableCell className={classes.taxCodeCell}>Tax Code</TableCell>
                    <TableCell className={classes.amountCell} align="right">Amount</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    distributionView?.map((distributionIndex, index) => {
                        return (
                            <DepositDistributionView
                                key={distributionIndex}
                                distributionIndex={distributionIndex}
                                distributionPosition={index + 1}
                            />
                        );
                    })
                }
                {
                    taxMode === TaxMode.Excluded && (
                       <>
                           <TableRow>
                               <TableCell className={classes.hiddenCell} colSpan={6} />
                               <TableCell className={classes.totalCell}>SUBTOTAL</TableCell>
                               <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(amount)}</TableCell>
                           </TableRow>
                           <TableRow>
                               <TableCell className={classes.hiddenCell} colSpan={6} />
                               <TableCell className={classes.totalCell}>TAX</TableCell>
                               <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(tax)}</TableCell>
                           </TableRow>
                       </>
                    )
                }
                <TableRow>
                    <TableCell className={classes.hiddenCell} colSpan={6} />
                    <TableCell className={classes.totalCell}>TOTAL</TableCell>
                    <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(total)}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}

export default DepositDistributionViews;


// WEBPACK FOOTER //
// ./src/components/DepositDistributionsView.tsx